// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== MyPayslip Layout ===== */

.mypayslip-container {
  display: flex;
  gap: 20px;
  padding: 25px;
  background: #f8f9fa;
  min-height: 100vh;
  font-family: "Poppins", sans-serif;
}

/* ===== LEFT INPUT PANEL ===== */

.payslip-left {
  width: 280px;
  background: #ffffff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  height: fit-content;
}

.payslip-left h3 {
  margin-bottom: 15px;
  color: #004c3f;
  font-weight: 600;
  text-align: center;
}

.mypayslip-input {
  width: 100%;
  padding: 8px 10px;
  margin-bottom: 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  outline: none;
  transition: 0.2s ease;
  font-size: 14px;
}

.mypayslip-input:focus {
  border-color: #007b55;
  box-shadow: 0 0 0 2px rgba(0, 123, 85, 0.1);
}

.mypayslip-btn {
  width: 100%;
  padding: 8px;
  background: rgb(116, 197, 167);
  border: none;
  border-radius: 6px;
  color: white;
  font-weight: 500;
  cursor: pointer;
  transition: 0.2s ease;
}

.mypayslip-btn:hover {
  background: #005f42;
}

.mypayslip-btn:disabled {
  background: #9ccfc1;
  cursor: not-allowed;
}

/* ===== RIGHT SECTION ===== */

.mypayslip-right {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

/* Optional empty state styling */
.mypayslip-empty {
  text-align: center;
  color: #666;
  margin-top: 50px;
  font-size: 15px;
}

/* ===== Responsive ===== */

@media (max-width: 992px) {
  .mypayslip-container {
    flex-direction: column;
  }

  .mypayslip-left {
    width: 100%;
  }

  .mypayslip-right {
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/UserPayslip/MyPayslip.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA,iCAAiC;;AAEjC;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,8BAA8B;;AAE9B;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA,2BAA2B;;AAE3B;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* ===== MyPayslip Layout ===== */\n\n.mypayslip-container {\n  display: flex;\n  gap: 20px;\n  padding: 25px;\n  background: #f8f9fa;\n  min-height: 100vh;\n  font-family: \"Poppins\", sans-serif;\n}\n\n/* ===== LEFT INPUT PANEL ===== */\n\n.payslip-left {\n  width: 280px;\n  background: #ffffff;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  height: fit-content;\n}\n\n.payslip-left h3 {\n  margin-bottom: 15px;\n  color: #004c3f;\n  font-weight: 600;\n  text-align: center;\n}\n\n.mypayslip-input {\n  width: 100%;\n  padding: 8px 10px;\n  margin-bottom: 12px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  outline: none;\n  transition: 0.2s ease;\n  font-size: 14px;\n}\n\n.mypayslip-input:focus {\n  border-color: #007b55;\n  box-shadow: 0 0 0 2px rgba(0, 123, 85, 0.1);\n}\n\n.mypayslip-btn {\n  width: 100%;\n  padding: 8px;\n  background: rgb(116, 197, 167);\n  border: none;\n  border-radius: 6px;\n  color: white;\n  font-weight: 500;\n  cursor: pointer;\n  transition: 0.2s ease;\n}\n\n.mypayslip-btn:hover {\n  background: #005f42;\n}\n\n.mypayslip-btn:disabled {\n  background: #9ccfc1;\n  cursor: not-allowed;\n}\n\n/* ===== RIGHT SECTION ===== */\n\n.mypayslip-right {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n/* Optional empty state styling */\n.mypayslip-empty {\n  text-align: center;\n  color: #666;\n  margin-top: 50px;\n  font-size: 15px;\n}\n\n/* ===== Responsive ===== */\n\n@media (max-width: 992px) {\n  .mypayslip-container {\n    flex-direction: column;\n  }\n\n  .mypayslip-left {\n    width: 100%;\n  }\n\n  .mypayslip-right {\n    justify-content: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
